import EastIcon from '@mui/icons-material/East';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Button, Card, CardActionArea, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import moment from "moment";
import { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../utils/MessageContext';
import { UserContext } from "../../utils/UserContext";
import { useAxios } from "../../utils/useAxios";

const OverlapDialog = ({ openDialog, setOpenDialog, entry, overlaps }) => {

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [selected, setSelected] = useState();
    const [index, setIndex] = useState(0);

    const [entryAsState, setEntryAsState] = useState();
    const [overlapsAsState, setOverlapsAsState] = useState([]);

    const { setUser } = useContext(UserContext);
    const { messages } = useContext(MessageContext);
    const axiosInstance = useAxios();

    const { t } = useTranslation();

    useEffect(() => {
        setSelected();
        setEntryAsState(entry);
        setOverlapsAsState(overlaps);
    }, [entry, overlaps])

    let fromList = overlaps.filter(e => e.id === selected);

    const getMessage = (companyMessageUid) => {
        const msg = messages?.filter(m => m?.companyMessageUid === companyMessageUid)[0];
        return msg;
    };

    const getTitle = (companyMessageUid) => {
        const message = getMessage(companyMessageUid);

        if (message?.timeOnlyMandatory) {
            return t("time-announcement");
        }
        if (message?.endDateTimeMandatory) {
            return t("datetime-announcement");
        }
        if (message?.endDateMandatory) {
            return t("date-announcement")
        }
        if (message?.timeOnlyMandatory === false && message?.endDateTimeMandatory === false && message?.endDateMandatory === false) {
            return t("without-enddate")
        }
        return null;
    };

    const increment = () => {
        if (index < overlaps.length - 1) {
            setIndex(index + 1);


            if (fromList.length > 0) {
                setSelected(overlaps[index + 1].id)
            };
        };
    };

    const decrement = () => {
        if (index > 0) {
            setIndex(index - 1);

            if (fromList.length > 0) {
                setSelected(overlaps[index - 1].id)
            };
        };
    };

    const manageClose = () => {
        setOpenDialog(false);
        document.title = "MbM - Dashboard";

        const update = async () => {

            await axiosInstance.current({
                url: "/entry",
                method: "DELETE",
                data: overlaps
            }).then((res) => {
                if (res.status === 200) {
                    axiosInstance.current({
                        url: "/entry",
                        method: "PUT",
                        data: entry
                    }).then((res) => {
                        if (res.status === 200) {
                            axiosInstance.current.get("/user").then((res) => {
                                setUser(res.data);
                            });
                        }
                    })
                }
            })
        }

        if (fromList.length === 0) {
            update();
        };
    };

    const CardItem = ({ obj }) => {

        return (
            <Fragment>
                {obj !== undefined ?
                    <Card
                        // raised={raised === obj.id ? true : false}
                        sx={{
                            bgcolor: selected !== obj.id && selected !== undefined ? theme.palette.mode === "dark" ? "action.disableBackground" : "action.selected" : "primary.dark",
                            border: theme.palette.mode === "dark" ? 1.5 : 0,
                            borderColor: selected !== obj.id && selected !== undefined ? "divider" : theme.palette.mode === "dark" ? "primary.main" : "primary.contrastText",
                            width: 230,
                            height: 205,
                            borderRadius: 2,
                            boxShadow: "none"
                        }}
                    >
                        <CardActionArea onClick={() => { setSelected(obj.id) }} sx={{ width: "100%", height: "100%" }}>
                            <CardContent>
                                <Box>
                                    <Grid container sx={{ borderBottom: 2, borderColor: (selected !== obj.id && selected !== undefined) || theme.palette.mode === "light" ? "divider" : "primary.main" }}>
                                        <Typography noWrap sx={{ my: .5, color: selected !== obj.id && selected !== undefined ? "text.disabled" : "primary.contrastText", fontWeight: "bold" }}>{getTitle(obj.companyMessageUid)}</Typography>
                                    </Grid>
                                    <Grid container sx={{ py: 3, borderBottom: 2, borderColor: (selected !== obj.id && selected !== undefined) || theme.palette.mode === "light" ? "divider" : "primary.main" }}>
                                        <Grid item xs={4} sx={{ textAlign: "center" }}>
                                            <Typography sx={{ color: selected !== obj.id && selected !== undefined ? "text.disabled" : "primary.contrastText", fontSize: 15 }}>
                                                {moment(obj.startDate).locale(localStorage.getItem("i18nextLng")).format("DD. MMM HH:mm")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} sx={{ color: selected !== obj.id && selected !== undefined ? "text.disabled" : "primary.contrastText", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <EastIcon />
                                        </Grid>
                                        <Grid item xs={4} sx={{ textAlign: "center" }}>
                                            <Typography sx={{ color: selected !== obj.id && selected !== undefined ? "text.disabled" : "primary.contrastText", fontSize: 15, pr: obj.EndDate !== null ? 0 : 1 }} >
                                                {obj.endDate !== null ? moment(obj.endDate).locale(localStorage.getItem("i18nextLng")).format("DD. MMM HH:mm") : "Kein Enddatum"}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    {obj.representation ?
                                        <Fragment>
                                            <Typography sx={{ color: selected !== obj.id && selected !== undefined ? "text.disabled" : "primary.contrastText", fontSize: 12, mt: .5 }}>Vertretung</Typography>
                                            <Typography noWrap sx={{ color: selected !== obj.id && selected !== undefined ? "text.disabled" : "primary.contrastText", fontSize: 14 }}>{obj.representation}</Typography>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <Typography sx={{ color: selected !== obj.id && selected !== undefined ? "text.disabled" : "primary.contrastText", fontSize: 12, mt: .5 }}>Keine Vertretung</Typography>
                                            <Box sx={{ width: "100%", height: 21 }} />
                                        </Fragment>
                                    }
                                </Box>
                            </CardContent>
                        </CardActionArea>
                    </Card > :
                    <div />
                }
            </Fragment>
        )
    }

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            maxWidth={"sm"}
            open={openDialog}
            onClose={() => {
                setOpenDialog(false);
                document.title = "MbM - Dashboard";
            }}
            sx={{
                "& .MuiDialog-paper": {
                    bgcolor: "background.default",
                    backgroundImage: "none",
                    borderRadius: fullScreen ? 0 : 6,
                    "& .MuiPaper-elevation": {
                        elevation: 2
                    }
                }
            }}
        >
            {selected === undefined ?
                <DialogTitle sx={{ display: "flex", justifyContent: "center", mt: fullScreen ? 5 : 0 }}>
                    <Typography>
                        {overlaps.length > 1 ? t("x-overlapping-entries", { x: overlaps.length }) : t("one-overlapping-entry")}
                    </Typography>
                </DialogTitle> :
                <DialogTitle sx={{ display: "flex", justifyContent: "center", mt: fullScreen ? 5 : 0 }}>
                    <Typography>
                        {fromList.length > 0 ? fromList.length === 1 ? t("keep-exisiting-entry") : t("keep-existing-entries") : t("activate-new-entry")}
                    </Typography>
                </DialogTitle>
            }
            <DialogContent sx={{ pb: 0, mt: fullScreen ? 5 : 2, pr: overlaps.length > 1 ? 1 : 2 }}>
                <Grid container>
                    <Grid item xs={12} sm={overlaps.length > 1 ? 5 : 6} sx={{ pl: overlaps.length > 1 ? 1 : fullScreen ? 0 : 2, display: fullScreen ? "flex" : "block", justifyContent: "center" }}>
                        <CardItem obj={entryAsState} />
                    </Grid>
                    <Grid item xs={12} sm={overlaps.length > 1 ? 7 : 6} sx={{ pl: overlaps.length > 1 ? fullScreen ? 1 : 4 : 0, mt: fullScreen ? 3 : 0 }}>
                        <Grid container>
                            <Grid
                                item
                                xs={1.25}
                                sx={{
                                    height: 205,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center"
                                }}
                            >
                                <IconButton onClick={decrement} disabled={index === 0} sx={{ py: 0, visibility: overlaps.length > 1 ? "visible" : "hidden" }}>
                                    <KeyboardArrowLeftIcon sx={{ color: index !== 0 ? "text.primary" : "text.disabled", fontSize: 32 }} />
                                </IconButton>
                            </Grid>
                            <Grid item xs={9.5} sx={{ display: "flex", justifyContent: "center" }}>
                                <CardItem obj={overlapsAsState[index]} />
                            </Grid>
                            <Grid
                                item
                                xs={1.25}
                                sx={{
                                    height: 205,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center"
                                }}
                            >
                                <IconButton onClick={increment} disabled={index === overlaps.length - 1} sx={{ py: 0, visibility: overlaps.length > 1 ? "visible" : "hidden" }}>
                                    <KeyboardArrowRightIcon sx={{ color: index !== overlaps.length - 1 ? "text.primary" : "text.disabled", fontSize: 32 }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    disabled={selected === undefined}
                    onClick={() => { manageClose(); }}
                    sx={{
                        backgroundColor: theme.palette.mode === "dark" ? "primary.dark" : "primary.main",
                        textTransform: "none",
                        borderRadius: 6,
                        py: 1.1,
                        my: 1,
                        mr: 1,
                        "&:hover": { backgroundColor: "primary.dark" },
                        "&:disabled": { backgroundColor: "action.disableBackground" }
                    }}
                >
                    <Typography fontSize={16}>{t("accept")}</Typography>
                </Button>
            </DialogActions>
        </Dialog >
    )
};

export default OverlapDialog;